// extracted by mini-css-extract-plugin
export default {"container":"WebDatenschutzScreen_container__XPnZ+","gaplessBox":"WebDatenschutzScreen_gaplessBox__Ak17g"};